import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoGamesListWidget" */ './CasinoGamesListWidget'),
  modules: ['./CasinoGamesListWidget'],
  loading: () => <div />
});

export default LoadableWidget;
